import React from 'react'

const ReportsGoalsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="#EBCF6D"
    />
    <g clipPath="url(#clip0_4425_24399)">
      <path
        d="M10.0001 6.29395L11.1457 8.73411L13.706 9.12484L11.853 11.024L12.2903 13.7057L10.0001 12.4389L7.70984 13.7057L8.14713 11.024L6.29419 9.12484L8.85442 8.73411L10.0001 6.29395Z"
        fill="white"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4425_24399">
        <rect
          width="8.23529"
          height="8.23529"
          fill="white"
          transform="translate(5.88232 5.88232)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default ReportsGoalsIcon
